export default __webpack_public_path__ + "static/media/calendar.e90d741b.svg";